/**
 * Canonical license-status -> list-builder chip variant (PD-14745).
 *
 * Single source for the Status cell across every license/registry list so the
 * colors can never drift between surfaces (the /licenses list, the registry
 * list, the embedded license/audit tables, the client-licenses tab). Spread
 * into each config's `colorRule.statusMap`.
 *
 * Semantics (mirrors LicenseStatusBadgeSelector + LicenseBreakdownChart):
 *   success  Active                                   (valid, can order)
 *   warning  Pending / Probation                      (attention / on watch)
 *   danger   Expired / Suspended / Revoked /
 *            Surrendered / Denied                      (problem)
 *   default  Cancelled / Inactive / Deceased /
 *            Unknown / Other                           (neutral / closed out)
 */
export const LICENSE_STATUS_STYLE_MAP: Record<string, string> = {
	Active: 'success',
	Pending: 'warning',
	Probation: 'warning',
	Expired: 'danger',
	Suspended: 'danger',
	Revoked: 'danger',
	Surrendered: 'danger',
	Denied: 'danger',
	Cancelled: 'default',
	Inactive: 'default',
	Deceased: 'default',
	Unknown: 'default',
	Other: 'default',
};
